import React from 'react'

export const books = ({ width, height, fill, theme }) => (
  <svg width={width || 200} height={height || 200} viewBox="0 0 200 200" fill="none">
    <g clipPath="url(#clip0_1401_179131)">
      <circle cx="100" cy="100" r="100" fill="#F5F5F5" />
      <g clipPath="url(#clip1_1401_179131)">
        <path
          d="M134.461 128.022C134.461 128.022 127.939 137.218 134.853 144.367H54.8324L54.4297 126.893L134.45 128.022H134.461Z"
          fill="white"
        />
        <path
          d="M55.5042 133.952V131.681C55.5042 127.642 58.4464 127.967 58.4464 127.967H136.061V123.324H57.6409C55.9964 123.324 54.8554 123.85 54.0611 124.622C53.994 124.689 53.9268 124.756 53.8597 124.823C53.8597 124.823 53.8485 124.834 53.8373 124.846C53.8038 124.89 53.759 124.924 53.7255 124.969C52.2376 126.636 46.4987 134.209 53.1102 144.915C53.8373 146.313 55.1798 147.499 57.6409 147.499H136.061V142.857H58.4464C58.4464 142.857 55.5042 143.181 55.5042 139.143V133.941V133.952Z"
          fill="#5E5E5E"
        />
        <path
          d="M148.478 105.033C148.478 105.033 142.303 113.748 148.859 120.516H73.0561L72.6758 103.959L148.478 105.033Z"
          fill="white"
        />
        <path
          d="M73.6824 110.66V108.501C73.6824 104.675 76.468 104.988 76.468 104.988H150V100.592H75.7073C74.1523 100.592 73.0672 101.095 72.3176 101.822C72.2505 101.889 72.1834 101.957 72.1275 102.024C72.1275 102.024 72.1163 102.035 72.1051 102.046C72.0715 102.091 72.038 102.124 72.0044 102.158C70.5948 103.735 65.158 110.917 71.4227 121.053C72.1163 122.373 73.3804 123.503 75.7185 123.503H150V119.106H76.468C76.468 119.106 73.6824 119.419 73.6824 115.593V110.671V110.66Z"
          fill="#9D9D9D"
        />
        <path
          d="M137.538 81.0928C137.538 81.0928 131.016 90.2884 137.94 97.4369H57.9203L57.5176 79.9629L137.538 81.0928Z"
          fill="white"
        />
        <path
          d="M58.5911 87.0338V84.7629C58.5911 80.7244 61.5333 81.0488 61.5333 81.0488H139.148V76.4062H60.7278C59.0833 76.4062 57.9423 76.9432 57.148 77.7039C57.0809 77.7711 57.0138 77.8382 56.9466 77.9053C56.9466 77.9053 56.9354 77.9165 56.9243 77.9277C56.8907 77.9724 56.8459 78.006 56.8124 78.0507C55.3245 79.7176 49.5856 87.2911 56.1971 97.997C56.9243 99.3954 58.2667 100.581 60.7278 100.581H139.148V95.9386H61.5221C61.5221 95.9386 58.5799 96.2631 58.5799 92.2246V87.0227L58.5911 87.0338Z"
          fill="#DADADA"
        />
        <path
          d="M123.051 112.426C120.143 111.811 116.484 112.102 116.484 112.102C116.484 112.102 120.624 115.033 120.422 121.499L123.577 117.08L127.929 120.246C127.929 120.246 126.564 113.813 123.04 112.415L123.051 112.426Z"
          fill="#5E5E5E"
        />
        <path
          d="M84.847 88.8892C81.9384 88.2739 78.2803 88.5648 78.2803 88.5648C78.2803 88.5648 82.4194 91.4958 82.2181 97.9618L85.3728 93.543L89.7245 96.7089C89.7245 96.7089 88.3597 90.2652 84.8358 88.878L84.847 88.8892Z"
          fill="#9D9D9D"
        />
        <path
          d="M98.2273 51.4464C98.2273 51.4464 91.6158 45.7187 83.6843 50.5626C75.7527 55.4065 76.8043 77.6238 96.9072 77.7133C112.882 77.7804 118.42 65.9894 115.69 56.9951C112.96 48.0008 103.698 47.3855 98.2385 51.4464H98.2273Z"
          fill="#9D9D9D"
        />
        <path
          d="M88.7513 41.1777C88.7513 41.1777 98.0588 43.1466 98.372 54.2105C98.372 54.2105 97.6113 46.3461 88.2031 42.7215C88.2031 42.7215 88.2367 41.793 88.7625 41.1777H88.7513Z"
          fill="#5E5E5E"
        />
        <path
          d="M96.5825 49.3329C96.5825 49.3329 92.1077 40.5064 105.588 33C105.588 33 109.213 42.8445 96.5825 49.3329Z"
          fill="#DADADA"
        />
        <path
          d="M96.5825 49.3329C96.5825 49.3329 100.229 36.4568 105.588 33C105.588 33 92.2532 37.6873 96.5825 49.3329Z"
          fill="#9D9D9D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1401_179131">
        <rect width="200" height="200" fill="white" />
      </clipPath>
      <clipPath id="clip1_1401_179131">
        <rect width="100" height="114.509" fill="white" transform="translate(50 33)" />
      </clipPath>
    </defs>
  </svg>
)
